import React from 'react';
import clsx from 'clsx';
import type { PublicAssetShare } from 'fym-shared/src/music24/assetShares';
import { TypedMemo } from '../../common/types';
import { getFullAPIFileURL } from '../../common/getFullAPIFileURL';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the share page; each part uses its own slice of it */
import styles from './AssetShare.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The picture that lights the page: the poster of a video, the picture itself, else the song cover. */
export function ambientSourceOf(share: PublicAssetShare): string | null {
  if (share.mediaKind === 'image') {
    return share.mediaUrl;
  }
  return share.posterUrl ?? share.song.artworkUrl;
}

/**
 * The ambient light of the theater page (design asset-share c1-c6): a blurred copy of the file
 * behind the player, so the light changes with each asset. With no picture, a soft glow in the
 * artist colour takes its place.
 */
const AssetShareAmbientComponent: React.FC<{ share: PublicAssetShare; className?: string }> = ({
  share,
  className,
}) => {
  const source = ambientSourceOf(share);
  return (
    <div className={clsx(styles.ambient, className)} aria-hidden data-testid="asset-share-ambient">
      {source !== null ? (
        <img className={styles.ambientPicture} src={getFullAPIFileURL(source)} alt="" />
      ) : (
        <div className={styles.ambientGlow} />
      )}
      <div className={styles.ambientVeil} />
    </div>
  );
};

export const AssetShareAmbient = TypedMemo(AssetShareAmbientComponent);
